import { __extends } from "tslib";
import React from 'react';
import { getDeviationType } from '../../DeviationViews/_helpers';
import { DeviationTypes } from '../../types/deviation';
import DailyDevThumb from '../../DeviationViews/Thumb/DailyDev';
import LazyContext from '../../LazyLoadingImage/LazyContext';
import MediaService from '../../utils/DeviationMediaService';
import s from './TwoColumnLayout.scss';
var MIN_CARD_WIDTH = 300;
var MIN_CARD_HEIGHT = 360;
var MIN_CARD_HEIGHT_LIT = 480;
var MAX_CARD_HEIGHT = 800;
var MOBILE_DD_CARD_HEIGHT = 354;
var TwoColumnLayoutRenderer = /** @class */ (function (_super) {
    __extends(TwoColumnLayoutRenderer, _super);
    function TwoColumnLayoutRenderer() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TwoColumnLayoutRenderer.prototype.render = function () {
        var _a = this.props, spacing = _a.spacing, container = _a.container, deviations = _a.deviations, measureRef = _a.measureRef;
        if (!container) {
            // If container not ready (measured) return something it
            // can measure
            return React.createElement("div", { className: s['two-col'], ref: measureRef });
        }
        // Calculate column width
        var render2Cols = true;
        var colWidth = container.width / 2 - spacing / 2;
        var colA = [];
        var colB = [];
        // Mobile handling
        if (colWidth <= MIN_CARD_WIDTH) {
            colWidth = container.width;
            render2Cols = false;
        }
        // Get preview dims
        // Calculate the size of each item for the given the col width
        // -- Text/unknown/tiny gets 1:1 ratio
        var items = deviations.map(function (deviation) {
            var type = getDeviationType(deviation);
            var preview = MediaService.getDeviationFile(deviation, 'preview');
            var cardHeight;
            if (!render2Cols && deviation.dailyDeviation) {
                // Mobile daily deviations
                cardHeight = MOBILE_DD_CARD_HEIGHT;
            }
            else if (!preview ||
                type === DeviationTypes.JOURNAL ||
                type === DeviationTypes.LITERATURE) {
                // Literature, journals and deviations with no preview
                cardHeight = MIN_CARD_HEIGHT_LIT;
            }
            else {
                // Everything else, fit to width
                var preWidth = preview.width, preHeight = preview.height;
                var widthRatio = colWidth / (preWidth || 0);
                var height = Math.floor((preHeight || 0) * widthRatio + spacing);
                cardHeight = Math.max(Math.min(height, MAX_CARD_HEIGHT), MIN_CARD_HEIGHT); // TODO maybe take these as props
            }
            colA.push(cardHeight);
            return {
                width: colWidth,
                height: cardHeight,
                deviation: deviation,
                preview: preview,
            };
        });
        // Bail on too small!
        if (!render2Cols) {
            return (React.createElement("div", { className: s['two-col'], ref: measureRef },
                React.createElement("div", { style: { width: colWidth } }, items.map(renderItem.bind(this, this.props)))));
        }
        var itemsB = [];
        // Try and balance the cols -  (this is pretty naive but cheap, could bin pack or partition)
        // Walk items and in reverse measuring the difference between the two column heights
        var diff = [];
        for (var i = colA.length; i >= 0; i--) {
            colB.push(colA.pop() || 0);
            var sumA = colA.length ? colA.reduce(function (a, b) { return a + b; }) : 0;
            var sumB = colB.length ? colB.reduce(function (a, b) { return a + b; }) : 0;
            var d = sumA - sumB;
            d = d < 0 ? d * -1 : d;
            diff.push({ idx: i, diff: d });
        }
        // Find the smallest diff at given index and cut the items in two
        var smallest = diff.reduce(function (a, b) { return (a.diff < b.diff ? a : b); });
        for (var i = items.length; i >= 0; i--) {
            var item = items.pop();
            if (!item) {
                continue;
            }
            itemsB.push(item);
            if (i === smallest.idx) {
                break;
            }
        }
        return (React.createElement("div", { className: s['two-col'], ref: measureRef },
            React.createElement(LazyContext.Provider, { value: true },
                React.createElement("div", { style: { width: colWidth, marginRight: spacing } }, itemsB.map(renderItem.bind(this, this.props))),
                React.createElement("div", { style: { width: colWidth } }, items.map(renderItem.bind(this, this.props))))));
    };
    return TwoColumnLayoutRenderer;
}(React.Component));
// TODO make a prop
function renderItem(props, item) {
    var styles = {
        width: item.width,
        marginBottom: props.spacing,
    };
    return (React.createElement("div", { key: "dd-" + item.deviation.deviationId, style: styles },
        React.createElement(DailyDevThumb, { key: "dd-th-" + item.deviation.deviationId, deviation: item.deviation, width: item.width, height: item.height })));
}
export default TwoColumnLayoutRenderer;
//# sourceMappingURL=TwoColumnLayoutRenderer.js.map